import ENV from "@/env"
import { AO, WUSDC } from "@/settings"

const classA = new Set([AO])
const classB = new Set([ENV.VITE_WRAPPED_AR_PROCESS, ENV.VITE_QAR_PROCESS])
const classC = new Set([WUSDC])

export function getTokenClass(token: string): "A" | "B" | "C" | "X" {
  if (classA.has(token)) return "A"
  if (classB.has(token)) return "B"
  if (classC.has(token)) return "C"

  return "X"
}

export function sortPoolAssets({
  token0,
  token1,
  token0Ticker,
  token1Ticker,
}: {
  token0: string
  token1: string
  token0Ticker?: string
  token1Ticker?: string
}): {
  token: string
  base: string
} {
  const [t0Class, t1Class] = [getTokenClass(token0), getTokenClass(token1)]

  // BaseAsset vs. Non-BaseAsset
  if (t0Class !== "X" && t1Class === "X") return { base: token1, token: token0 }
  if (t0Class === "X" && t1Class !== "X") return { base: token0, token: token1 }

  // BaseAsset vs. BaseAsset
  if (t0Class !== "X" && t1Class !== "X") {
    // If they are equal, sort by token ticker and the one with the lower ticker is the base
    if (t0Class === t1Class) {
      if (token0Ticker && token1Ticker) {
        return token0Ticker < token1Ticker
          ? { base: token0, token: token1 }
          : { base: token1, token: token0 }
      }
      // if no tickers, sort by token address
      return token0 < token1 ? { base: token0, token: token1 } : { base: token1, token: token0 }
    }

    // By default return the one with the lower class as the base
    return t0Class < t1Class ? { base: token0, token: token1 } : { base: token1, token: token0 }
  }

  // Non-BaseAsset vs. Non-BaseAsset
  return { base: token0, token: token1 }
}
